@if (visible) {
  <div class="cookie-consent" role="dialog" aria-labelledby="cookie-consent-title" aria-live="polite">
    <div class="cookie-consent__inner mx-auto max-w-7xl">
      <div class="cookie-consent__content">
        <div class="cookie-consent__icon" aria-hidden="true">
          <i class="pi pi-shield"></i>
        </div>
        <div class="cookie-consent__text">
          <p id="cookie-consent-title" class="cookie-consent__title">We value your privacy</p>
          <p class="cookie-consent__desc">
            GoCareMo uses cookies for sign-in, security, and to improve your experience. Essential cookies are required
            for the platform to work. With your permission, we may also use optional cookies for analytics.
            <a routerLink="/privacy" class="cookie-consent__link">Privacy Policy</a>
          </p>
        </div>
      </div>

      <div class="cookie-consent__actions">
        <button type="button" class="cookie-consent__btn cookie-consent__btn--secondary" (click)="acceptEssentialOnly()">
          Essential only
        </button>
        <button type="button" class="cookie-consent__btn cookie-consent__btn--primary" (click)="acceptAll()">
          Accept all cookies
        </button>
      </div>
    </div>
  </div>
}
